import React from 'react';
import { Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-20 pb-10 border-t border-gray-800" data-id="element-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-51">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-52">
          <div className="col-span-1 lg:col-span-2" data-id="element-53">
            <h2 className="text-4xl font-black tracking-tighter mb-6" data-id="element-54">
              RAVEN<span className="text-slate-400" data-id="element-55">ADVISORS</span>.
            </h2>
            <p className="text-xl font-medium max-w-md text-gray-400" data-id="element-56">
              We provide the fastest, fairest way to sell your home. No games,
              no hidden fees, just results.
            </p>
          </div>

          <div data-id="element-57">
            <h3 className="text-lg font-bold uppercase tracking-wider mb-6 text-slate-400" data-id="element-58">
              Contact
            </h3>
            <ul className="space-y-4" data-id="element-59">
              <li className="flex items-center gap-3" data-id="element-60">
                <Phone className="w-5 h-5 text-slate-400" data-id="element-61" />
                <span className="text-xl font-bold" data-id="element-62">630-639-3533</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-63">
                <Mail className="w-5 h-5 text-gray-500" data-id="element-64" />
                <span className="font-medium" data-id="element-65">ravenadvisorsllc@gmail.com</span>
              </li>
            </ul>
          </div>

          <div data-id="element-66">
            <h3 className="text-lg font-bold uppercase tracking-wider mb-6 text-slate-400" data-id="element-67">
              Legal
            </h3>
            <ul className="space-y-4 font-medium text-gray-400" data-id="element-68">
              <li data-id="element-69">
                <a href="#" className="hover:text-white transition-colors" data-id="element-70">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-71">
                <a href="#" className="hover:text-white transition-colors" data-id="element-72">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-73">
                <a href="#" className="hover:text-white transition-colors" data-id="element-74">
                  Disclosures
                </a>
              </li>
              <li data-id="element-75">
                <a href="#" className="hover:text-white transition-colors" data-id="element-76">
                  Accessibility
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-77">
          <p className="text-sm text-gray-500 font-medium" data-id="element-78">
            © {new Date().getFullYear()} Raven Advisors. All rights reserved.
          </p>
          <p className="text-sm text-gray-600 font-medium" data-id="element-79">
            Designed for speed. Built for trust.
          </p>
        </div>
      </div>
    </footer>;
}